/**
 * Cihaz Fingerprint + İsim üretimi.
 * Personel cihaz kayıt sistemi için kullanılır (Faz 1.4).
 */

const FINGERPRINT_KEY = 'shiftbeat_fingerprint'

/**
 * Cihaz fingerprint üretir veya localStorage'dan döner.
 * SHA-256 hash kullanılır (~64 karakter).
 */
export async function cihazFingerprint(): Promise<string> {
  // Önce cache'e bak
  const cached = localStorage.getItem(FINGERPRINT_KEY)
  if (cached) return cached

  // Yeni fingerprint üret — cihaz parmak izleri + rastgele
  const bilesenler = [
    navigator.userAgent,
    navigator.language,
    `${screen.width}x${screen.height}`,
    `${screen.colorDepth}`,
    new Date().getTimezoneOffset().toString(),
    navigator.hardwareConcurrency?.toString() ?? '0',
    Date.now().toString(),
    Math.random().toString(36),
  ].join('|')

  const encoder = new TextEncoder()
  const data = encoder.encode(bilesenler)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const fingerprint = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')

  // Kaydet
  localStorage.setItem(FINGERPRINT_KEY, fingerprint)
  return fingerprint
}

/**
 * Cihaz adını user-agent'tan tahmin eder.
 */
export function cihazAdi(): string {
  const ua = navigator.userAgent
  if (/iPhone|iPod/.test(ua)) return 'iPhone'
  if (/iPad/.test(ua)) return 'iPad'
  if (/Android/.test(ua)) return 'Android Telefon'
  if (/Macintosh/.test(ua)) return 'Mac'
  if (/Windows/.test(ua)) return 'Windows PC'
  if (/Linux/.test(ua)) return 'Linux'
  return 'Telefon'
}

/**
 * Fingerprint'i sıfırla (test/debug için).
 */
export function fingerprintSifirla(): void {
  localStorage.removeItem(FINGERPRINT_KEY)
}
